<template>
  <div class="w-full px-4 overflow-hidden flex flex-col gap-6 mt-7">
    <div class="overflow-auto snap-x snap-mandatory List">
      <div class="flex items-center gap-3 flex-nowrap">
        <div
          :style="{
            borderBottom: '3px',
            borderBottomColor:
            activeMenuId === item?.id ? '#13499B' : 'transparent',
            borderBottomStyle: 'solid',

          }"
          v-for="item in menuList"
          @click="activeMenuId = item?.id"
          :key="item?.id"
          :class="activeMenuId === item?.id ? 'text-primary' : 'text-gray-500'"
          class="w-30 px-1 py-1 flex-shrink-0 cursor-pointer snap-center"
        >
          {{ item?.label }}
        </div>
      </div>
    </div>
    <div class="flex flex-col gap-4 pb-6">
      <div
        v-for="item in pageInfoList"
        :key="item?.id"
        class="flex justify-between gap-4 py-2"
        @click="() => handleNavigateToDetail(item?.id,item?.title)"
      >
        <div class="relative">
          <div class="w-36 h-24">
            <img
              @error="handleImageError"
              class="w-full h-full"
              :src="'/mainsys/UserFiles/menupic/' + item?.picUrl"
            />
          </div>
          <div
            style="transform: translate(-12px, 0)"
            class="absolute z-10 top-10 right- w-12 h-12 bg-gold grid place-items-center"
          >
            <div class="flex items-center flex-col text-white">
              <span class="text-base font-normal">{{
                item?.addDate | day("DD")
              }}</span>
              <span class="text-xs font-thin">{{
                item?.addDate | day("YYYY.MM")
              }}</span>
            </div>
          </div>
        </div>
        <div class="flex flex-1 flex-col gap-1 h-24">
          <div
            class="text-primary text-base cursor-pointer font-semibold"
            style="
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
            "
          >
            {{ item.title }}
          </div>
          <div class="text-xs text-gray-500" style="
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;color:#333333;opacity: 0.6;
            ">{{ item?.descripton }}</div>
        </div>
      </div>
      <div
        class="w-full flex flex-col items-end"
        @click="handleNavigateToList(activeMenuId)"
      >
        <div class="flex cursor-pointer text-primary text-xs">查看更多→</div>
      </div>
    </div>
  </div>
</template>

<script>
import mixins from "../hooks";
import { array_ } from "../utils";

export default {
  name: "middleMenu",
  mixins: [mixins],
  props: {
    info: {
      default: () => ({}),
    },
  },

  data() {
    return {
      activeMenuId: null,
    };
  },
  computed: {
    // 菜单列表
    menuList() {
      return array_(this.info?.twoData).map((item) => {
        return {
          id: item?.id,
          label: item?.label,
        };
      });
    },
    // 不同菜单对应界面信息映射关系
    mappingPageInfo() {
      return array_(this.info?.twoData).reduce(
        (acc, cur) => acc.set(cur?.id, array_(cur?.data)),
        new Map()
      );
    },
    // 根据选择的菜单选择不同的pageInfo
    pageInfoList() {
      return this.mappingPageInfo?.get(this.activeMenuId);
    },
    // 当前界面列表ID集合
    pageInfoIDList() {
      return array_(this.pageInfoList).map(({ id }) => id);
    },
  },
  watch: {
    // 数据加载后,默认选中第一个
    menuList: {
      immediate: true,
      handler(val) {
        if (val?.length) {
          this.activeMenuId = val[0]?.id;
        }
      },
    },
  //   监听activeMenuId
    activeMenuId(val) {
      console.log(val,'val')
      // if (val) {
      //   this.$router.push({
      //     path: "List:menuId",
      //     name: "List",
      //     params: { menuId: val },
      //   });
      // }
    },
  },
  methods: {
    handleImageError(e){
      e.target.src = require('../../../assets/2.png')
    },
  },
};
</script>
<style lang="less" scoped>
.List {
  //scroll-snap-type: x mandatory;
  //scroll-behavior: smooth;
  //overflow: -moz-scrollbars-none;
  &::-webkit-scrollbar {
    width: 0 !important;
  }
}
</style>
